(() => {
  const mounted = new WeakSet();

  function mount(root = document) {
    root.querySelectorAll('[data-lus-scent-rail]').forEach((rail) => {
      if (mounted.has(rail)) return;

      const section = rail.closest('.lus-scents__rail');
      const previous = section?.querySelector('[data-lus-scent-previous]');
      const next = section?.querySelector('[data-lus-scent-next]');
      if (!previous || !next) return;

      const update = () => {
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= maximum - 2;
      };

      const move = (direction) => {
        const distance = Math.max(rail.clientWidth * 0.82, 220);
        rail.scrollBy({
          left: direction * distance,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, { passive: true });

      let drag = null;
      const finishDrag = (event) => {
        if (!drag) return;
        if (rail.hasPointerCapture?.(event.pointerId)) rail.releasePointerCapture(event.pointerId);
        drag = null;
        rail.classList.remove('is-dragging');
      };

      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { x: event.clientX, scrollLeft: rail.scrollLeft };
        rail.setPointerCapture?.(event.pointerId);
        rail.classList.add('is-dragging');
      });
      rail.addEventListener('pointermove', (event) => {
        if (!drag) return;
        rail.scrollLeft = drag.scrollLeft - (event.clientX - drag.x);
      });
      rail.addEventListener('pointerup', finishDrag);
      rail.addEventListener('pointercancel', finishDrag);

      new ResizeObserver(update).observe(rail);
      update();
      mounted.add(rail);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
